var _defineProperty = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _unspecifiedPropsFilter = require('./exclude-filter');

var BASE_IGNORE_LIST = ['children', 'history', 'location', 'params', 'route', 'routes', 'routeParams', 'context', 'slug', 'fn', 'match', 'staticContext'];
/**
 * Check if there are unused properties or properties that were not set
 *
 * @export
 * @param {any} propTypes
 * @param {any} [ignoreData=[]]
 * @returns {Boolean}
 */

function extraPropertiesChecker() {
  var propTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ignoreData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ignoreList = BASE_IGNORE_LIST.concat(ignoreData);
  return _objectSpread(_objectSpread({}, propTypes), {}, {
    fn: function fn(props, self, componentName) {
      var unspecifiedProps = _unspecifiedPropsFilter(props, propTypes, ignoreList);

      if (unspecifiedProps.length) {
        console.warn("Component ".concat(componentName, " has unspecified props: ").concat(unspecifiedProps.join(', ')));
      }
    }
  });
}

module.exports = extraPropertiesChecker;